<template>
    <span @click="toggle" class="flex items-center h-64 ml-16 cursor-pointer">
        <img v-if="isFavourite" src="images/heart.svg" alt="Heart" class="heart">
        <img v-else src="images/heart-o.svg" alt="Heart" class="heart-o">
        <svg v-if="isFavourite" xmlns="http://www.w3.org/2000/svg" width="27.706" height="24" viewBox="0 0 27.706 24" class="animating-heart"><path d="M27.706,40.434a7.476,7.476,0,0,0-13.853-3.907,7.476,7.476,0,1,0-11.285,9.54l10.6,10.6a.966.966,0,0,0,1.365,0l10.6-10.6A7.454,7.454,0,0,0,27.706,40.434Z" transform="translate(0 -32.952)" fill="#f80089"/></svg>
        <span v-if="showNumberOfFavourites" class="favourites-count ml-4 font-14">{{ numberOfFavourites }}</span>
    </span>
</template>

<script>
    import { call, get } from 'vuex-pathify'

    export default {
        props: {
            value: {
                type: Object,
                required: true
            },

            favourite: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                chart: this.value,
                isFavourite: false,
            }
        },

        mounted() {
            this.isFavourite = this.favourite
        },

        computed: {
            user: get('auth/user'),

            favourites() {
                return this.chart.favourites
            },

            numberOfFavourites() {
                return this.favourites.length
            },

            showNumberOfFavourites() {
                return this.numberOfFavourites > 0
            }
        },

        methods: {
            favourited: call('charts/favourited'),
            unfavourited: call('charts/unfavourited'),

            toggle() {
                if (this.isFavourite) {
                    this.unfavourited(this.chart)
                } else {
                    this.favourited(this.chart)
                }

                this.isFavourite = !this.isFavourite
            }
        }
    }
</script>
